(function() {
    'use strict';

    angular
        .module('app')
        .directive('sbResize', sbResize);

    sbResize.$inject = ['$window', '$timeout'];
    
    function sbResize ($window, $timeout) {
        // Usage:
        //     <sbResize></sbResize>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
        };
        return directive;

        function link(scope, element, attrs) {
            //add the handle
            var handle = angular.element('<div class="sidebar-handle"></div>');
            var newWidth = element.width();
            handle.css("top", "0");
            handle.css("left", "300px");
            handle.css("bottom", "0");
            handle.css("border-left", "1px solid rgb(220,220,220)");
            handle.css("width", "10px");
            handle.css("position", "absolute");
            handle.css("z-index", "15");
            handle.css("cursor", "ew-resize");
            handle.css("background-color", "transparent");
            element.prepend(handle);
            $(handle).on('touchstart', down);
            $(handle).on('mousedown', down);

            scope.$watch(function () {
                return scope.collapse;
            }, function (value) {
                //console.log(value);
            });

            //mouse/touch down listener
            function down(event) {
                //prevent the default behavior to avoid highlighting text, etc...
                event.preventDefault();

                //add listeners
                $(window).on('mouseup', up);
                $(window).on('touchend', up);
                $(window).on('mousemove', move);
                $(window).on('touchmove', touchMove);

                //set the handle styles
                setMoveStyle();
            }

            //mouse/touch up listener
            function up(event) {
                event.preventDefault();
                //remove the listeners
                $(window).off('mousemove', move);
                $(window).off('touchmove', touchMove);
                //set the element's width
                element.css('width', newWidth);
                //reset the handle style to the default values.
                resetHandleStyle();
                handle.css("right", "0px");
                //fire the onResize event to notify subscribers
                //scope.onResize(newWidth);
            }

            //handle the move event
            function move(event) {
                //set the position of the handle
                var position = angular.element(element.parent()).width() - event.clientX;
                setHandlePosition(position);
            }

            //handle the move event
            function touchMove(event) {
                //get the touch object
                var touchobj = event.originalEvent.changedTouches[0];
                var position = angular.element(element.parent()).width() - touchobj.clientX;
                //set the position of the handle
                setHandlePosition(position);
            }

            function setHandlePosition(position) {
                ////calculate the width based on the position of the handle
                //position = position - $(element).offset().left;
                //////calculate half the parent's width and prevent the size to be above that
                //var halfParentWidth = Math.floor(angular.element(element.parent()).width() / 2);
                //if (position > halfParentWidth) {
                //    position = halfParentWidth - 2;
                //}

                //set the position of the handle
                var calculatedWidth = element.width() + (position * -1);
                console.log("handle position", calculatedWidth);
                //console.log("Window Width: ", $(window).width());
                //console.log("Calculated width: ", calculatedWidth);
                var windowWidth = $(window).width();
                if (calculatedWidth >= 150 && calculatedWidth < (windowWidth/2)) {
                    newWidth = calculatedWidth;
                    handle.css("left", newWidth + "px");
                }
                scope.vm.onResize();
            }

            //default handle styles
            function setMoveStyle() {
                //handle.css("width", "0");
                handle.css("border-left", "1px dotted black");
                handle.css("background-color", "rgba(240,240,240, .7)");
                //handle.css("width", "1px");
            }

            //moving handle styles
            function resetHandleStyle() {
                handle.css("border-left", "1px solid rgb(220,220,220)");
                handle.css("width", "10px");
                handle.css("left", element.width() + "px");
                handle.css("background-color", "transparent");
            }
        }
    }

})();